import React, { useEffect, useState } from "react";
import {
  Package,
  ShoppingCart,
  Warehouse,
  Settings,
  Users,
  Sprout,
  LogOut,
  Leaf,
  FlaskConical,
  Globe,
} from "lucide-react";
import { NavLink, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const Dashboard = ({ onUseCaseSelect }) => {
  const [cards, setCards] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const authData = JSON.parse(localStorage.getItem("authData"));

    if (authData) {
      const { loginUser, userList } = authData;
      console.log(userList);

      const allUsers = [loginUser, ...(userList || [])].filter(Boolean);

      const useCaseCardsMap = {
        Procurement: {
          icon: <Package size={48} color="#000" strokeWidth={2.5} />,
          title: "Value Chain Development(VCD)",
          desc: "Manage procurement workflows",
          path: "/",
        },
        Sales: {
          icon: <ShoppingCart size={48} color="#000" strokeWidth={2.5} />,
          title: "Sales",
          desc: "Track and analyze sales",
          path: "/",
        },
        Warehouse: {
          icon: <Warehouse size={48} color="#000" strokeWidth={2.5} />,
          title: "Warehouse",
          desc: "Handle warehouse operations",
          path: "/",
        },
        AdminPanel: {
          icon: <Settings size={48} color="#000" strokeWidth={2.5} />,
          title: "Admin Panel",
          desc: "System administration tools",
          path: "/",
        },
        "Agri Promoter": {
          icon: <Globe size={48} color="#000" strokeWidth={2.5} />,
          title: "Extension Services",
          desc: "Provide field & extension support services",
          path: "/",
        },
        "Market Detail": {
          icon: <ShoppingCart size={48} color="#000" strokeWidth={2.5} />,
          title: "Market Detail",
          desc: "Access and analyze market insights",
          path: "/",
        },
        CommercialFarming: {
          icon: <Package size={48} color="#000" strokeWidth={2.5} />,
          title: "Commercial Farming",
          desc: "Manage commercial farming operations",
          path: "/",
        },
        Nursery: {
          icon: <Sprout size={48} color="#000" strokeWidth={2.5} />,
          title: "Nursery",
          desc: "Track nursery operations and growth",
          path: "/",
        },
        "Seed Production": {
          icon: <Leaf size={48} color="#000" strokeWidth={2.5} />,
          title: "Seed Production",
          desc: "Monitor and manage seed production lifecycle",
          path: "/",
        },
        "Research Program": {
          icon: <FlaskConical size={48} color="#000" strokeWidth={2.5} />,
          title: "Research program for R&D",
          desc: "Manage research & development activities",
          path: "/",
        },
      };

      const mappedCards = allUsers
        .map((user) => {
          const cardTemplate = useCaseCardsMap[user.useCase];
          if (!cardTemplate) return null;
          return { ...cardTemplate, user };
        })
        .filter(Boolean);

      setCards(mappedCards);
    }
  }, []);

  const handleCardClick = (card) => {
    console.log(card.user);
    const data = card.user || [];
    Cookies.set("token", data.Token);
    localStorage.setItem("token", data.Token);
    localStorage.setItem("attachmentFolder", data.attachmentFolder);
    localStorage.setItem("orgId", data.orgid);
    localStorage.setItem("id", data.userId);
    localStorage.setItem("userEmail", data.userEmail);
    localStorage.setItem("userContact", data.workContactNo);
    localStorage.setItem("orgCode", data.orgCode);

    localStorage.setItem("warehouseId", data.warehouseId);

    localStorage.setItem("organizationName", data.organizationName);
    localStorage.setItem("organizationAddress", data.organizationAddress);

    localStorage.setItem("organizationIcon", data.organizationIcon);

    localStorage.setItem("employeeName", data.employeeName);
    localStorage.setItem("useCase", data.useCase);
    localStorage.setItem("userIcon", data.userIcon);

    localStorage.setItem("userName", data.userName);
    localStorage.setItem("appName", data.appName);
    //Technical Setting
    localStorage.setItem("pageSize", 25);
    localStorage.setItem("decimalPattern", "^\\d*(\\.\\d{1,2})?$");
    localStorage.setItem("integerPattern", "^\\d*");
    localStorage.setItem("currencyCode", data.currency);
    localStorage.setItem("dateFormat", "dd/MM/yyyy");
    localStorage.setItem("empId", data.empId);

    localStorage.setItem("selectedUseCase", card.title);

    if (onUseCaseSelect) onUseCaseSelect();

    navigate(card.path);
  };
  const handleLogout = () => {
    localStorage.clear();
    Cookies.remove("token");
    navigate("/360Login");
  };

  return (
    <>
      <div className="dashboard-wrapper">
        <div className="content-header dashboard-navbar">
          <nav className="navbar-nav navbar-expand mt-auto">
            {/* LEFT SIDE */}
            <ul className="navbar-nav">
              <li className="nav-item dropdown">
                <img
                  src={require("../../../assests/images/goldanIcon.png")}
                  height="120"
                  className="user-image"
                  alt=""
                />
              </li>
              {/* <li className="nav-item dropdown">
                <img
                  src="dist/img/360logo1.png"
                  height="100"
                  width="100"
                  className="user-image"
                  alt=""
                />
              </li> */}
            </ul>

            {/* RIGHT SIDE */}
            <ul className="navbar-nav ml-auto" style={{}}>
              <li className="nav-item user-menu d-flex mt-2">
                <img
                  src={`${process.env.REACT_APP_FILE_URL}${localStorage.getItem(
                    "userIcon"
                  )}`}
                  className="user-image img-circle elevation-2"
                  alt="usericon"
                />
                <span className="d-none d-md-inline text-dark ">
                  {localStorage.getItem("employeeName")}
                </span>
              </li>

              <li className="nav-item user-menu d-flex">
                {" "}
                <button
                  className="btn"
                  title="Logout"
                  onClick={handleLogout}
                  style={{ height: "40px" }}
                >
                  <LogOut />
                </button>
              </li>
            </ul>
          </nav>
        </div>

        <section className="content dashboard-content mb-5">
          <div className="container-fluid">
            <div className="row justify-content-center">
              {cards.map((card, idx) => (
                <div
                  className={`col-12 ${
                    cards?.length <= 4 ? "col-md-6" : "col-md-4"
                  } d-flex justify-content-center`}
                  key={idx}
                >
                  <div
                    className="card border-0 shadow-sm text-center card-bg cursor-pointer mb-4"
                    onClick={() => handleCardClick(card)}
                    style={{
                      borderRadius: "20px",
                      maxWidth: "325px",
                      minWidth: "325px",
                      minHeight: "170px",
                      background: "#fff",
                      cursor: "pointer",
                      backgroundColor: "#b6e2d3",
                    }}
                  >
                    <div className="my-3">{card.icon}</div>
                    <h5 className="mb-2 font-weight-bold mx-2">{card.title}</h5>
                    <p className="text-muted mb-1 font-weight-bold mx-2">
                      {card.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <br />
        </section>

        <div className="fixed-bottom-logo mt-1">
          <span className="powered-by-text">Powered By</span>
          <img
            src="dist/img/360logo1.png"
            width="100"
            height="100"
            alt="360 logo"
          />
        </div>
      </div>
    </>
  );
};

export default Dashboard;
